var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCaretinline = function SvgCaretinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M4.553 5.57 2.155 2.829A.5.5 0 0 1 2.531 2h4.796a.5.5 0 0 1 .377.83L5.306 5.57a.5.5 0 0 1-.753 0Z",
    opacity: 0.75
  })));
};

export default SvgCaretinline;